<div class="flex md:flex-row h-full w-full">
  <div
    class="md:flex hidden relative w-full md:w-1/2 overflow-hidden text-white p-20 bg-primary justify-center items-center">
    <div
      class="absolute inset-0 animate-[spin_100s_linear_infinite] w-[200%] h-[200%] bg-[linear-gradient(to_bottom_left,_oklch(75%_0.08_270)_0%,_oklch(40%_0.12_255)_50%,_oklch(25%_0.14_250)_100%)]"></div>
    <div
      class="absolute animate-bounce floating-shape-2 top-0 -translate-y-2/3 left-2/5 w-192 h-192 opacity-60 bg-[radial-gradient(at_50%_55%,_oklch(98%_0.02_240)_0%,_oklch(65%_0.12_250)_45%,_oklch(30%_0.15_260)_90%)] rounded-full shadow-lg shadow-gray-700/40"></div>
    <div
      class="absolute animate-bounce floating-shape-2 top-4/6 -left-1/10 w-120 h-120 opacity-65 bg-[radial-gradient(at_50%_55%,_oklch(98%_0.02_240)_0%,_oklch(70%_0.12_250)_45%,_oklch(32%_0.16_265)_90%)] rounded-full shadow-xl shadow-gray-800/40"></div>
    <div
      class="absolute animate-bounce floating-shape-3 top-4/6 translate-y-2/5 -right-10 w-64 h-64 opacity-75 bg-[radial-gradient(at_50%_55%,_oklch(99%_0.015_240)_0%,_oklch(72%_0.13_250)_40%,_oklch(38%_0.18_265)_85%)] rounded-full shadow-lg shadow-gray-900/40"></div>
    <div
      class="absolute animate-bounce floating-shape-4 -top-5 -left-5 w-40 h-40 opacity-70 bg-[radial-gradient(at_50%_55%,_oklch(99%_0.01_240)_0%,_oklch(82%_0.12_250)_35%,_oklch(42%_0.15_265)_85%)] rounded-full shadow-lg shadow-gray-900/30"></div>
    <!-- เนื้อหา -->
    <div class="flex-col relative z-10 justify-center space-y-4">
      <div class="flex flex-col items-center justify-center">
        <img class="size-100" src="/img_login.png" alt="" />
      </div>
    </div>
  </div>

  <div class="flex h-full w-full justify-center md:w-1/2 bg-base-100">
    <div
      class="flex flex-col justify-center items-center w-80 md:w-85 lg:w-100">
      <!-- Logo -->
      <div
        class="flex flex-row items-center space-x-1 mb-4 w-full text-center justify-center">
        <img class="h-20 w-20" src="/myrank_logo_no_text.png" alt="" />
        <h1 class="text-6xl font-bold">MyRank</h1>
      </div>

      <!-- Login Error Alert -->
      @if (loginError()) {
      <div role="alert" class="alert alert-error bg-error mb-5">
        <span class="text-white"
          >Invalid email or password. Please try again.</span
        >
      </div>
      }

      <!-- Form -->
      <form [formGroup]="loginForm" (submit)="onSubmit($event)" class="w-full">
        <!-- Email -->
        <label
          class="input w-full rounded-lg"
          [class.input-error]="shouldShowError('email')"
          [class.input-success]="email?.valid && email?.touched">
          <svg
            class="h-[1em] opacity-50"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24">
            <g
              stroke-linejoin="round"
              stroke-linecap="round"
              stroke-width="2.5"
              fill="none"
              stroke="currentColor">
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </g>
          </svg>
          <input
            type="email"
            formControlName="email"
            placeholder="Email"
            class="w-full placeholder-gray-300 text-base"
            autocomplete="email" />
        </label>

        <!-- Email validation hint -->
        <div
          class="text-error text-sm mt-1"
          [class.opacity-100]="shouldShowError('email')"
          [class.opacity-0]="!shouldShowError('email')">
          {{ getEmailError() || 'Please enter valid email address' }}
        </div>
        

        <!-- Password -->
        <label
          class="input w-full mt-2 rounded-lg"
          [class.input-error]="shouldShowError('password')"
          [class.input-success]="password?.valid && password?.touched">
          <svg
            class="h-[1em] opacity-50"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24">
            <g
              stroke-linejoin="round"
              stroke-linecap="round"
              stroke-width="2.5"
              fill="none"
              stroke="currentColor">
              <path
                d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
              <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
            </g>
          </svg>
          <input
            type="password"
            formControlName="password"
            placeholder="Password"
            class="w-full placeholder-gray-300 text-base"
            autocomplete="current-password" />
        </label>

        <!-- Password validation hint -->
        <div
          class="text-error text-sm mt-1"
          [class.opacity-100]="shouldShowError('password')"
          [class.opacity-0]="!shouldShowError('password')">
          {{ getPasswordError() || 'Please enter password.' }}
        </div>

        <div class="w-full mt-2">
          <app-button
            [type]="'submit'"
            [color]="'primary'"
            [label]="isLoading() ? 'Logging in...' : 'Log in'"
            [loading]="isLoading()"
            [disabled]="loginForm.invalid || isLoading()" />
        </div>
      </form>

      <div class="divider">OR</div>
      <button
        class="btn bg-white text-black border-[#e5e5e5] w-full rounded-lg"
        (click)="loginWithGoogle()">
        <svg
          aria-label="Google logo"
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512">
          <g>
            <path d="m0 0H512V512H0" fill="#fff"></path>
            <path
              fill="#34a853"
              d="M153 292c30 82 118 95 171 60h62v48A192 192 0 0190 341"></path>
            <path
              fill="#4285f4"
              d="m386 400a140 175 0 0053-179H260v74h102q-7 37-38 57"></path>
            <path
              fill="#fbbc02"
              d="m90 341a208 200 0 010-171l63 49q-12 37 0 73"></path>
            <path
              fill="#ea4335"
              d="m153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55"></path>
          </g>
        </svg>
        Login with Google
      </button>
    </div>
  </div>
</div>
